import { Component, ContentChildren, Input, OnInit, QueryList, TemplateRef, ViewEncapsulation } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import * as isEmpty from 'lodash/isEmpty';

@Component({
	selector: 'ac-nav-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

	@ContentChildren(TemplateRef) public itemRefs: QueryList<TemplateRef<any>>; // so that you can wrap each item with a div

	@Input() public appName: string = '';
	@Input() public gridClass: string = 'grid-980';
	@Input() public shouldOverridePadding: boolean = true;
	@Input() public shouldAllowLowerCaseInTitle: boolean = false;
	@Input() public customContentClass: { [name: string]: string } = {};

	public expanded: boolean = false;

	public contentClass: { [name: string]: string } = {
		appName: 'col-6 col-md-8 col-sm-18 dz-col-18 dz-col-md-8 dz-col-lg-6',
		actionButtons: 'col-18 col-md-16 dz-col-md-16 dz-col-lg-18'
	};

	constructor(
		private contentService: ContentService
	) { }

	public ngOnInit(): void {
		if (!this.appName) {
			this.appName = this.contentService.get('APP_HEADER_TITLE', 'APP_HEADER_TITLE');
		}

		this.updateContentClasses();
	}

	public toggleMobileNav(): void {
		this.expanded = !this.expanded;
		document.body.style.overflow = document.body.style.overflow ? '' : 'hidden';
	}

	private updateContentClasses(): void {
		if (!isEmpty(this.customContentClass)) {
			this.contentClass = this.customContentClass;
		} else if (this.appName.length > 20) {
			this.contentClass = {
				appName: 'col-8 col-sm-18 dz-col-18 dz-col-lg-8',
				actionButtons: 'col-16 dz-col-lg-16 col-sm-6 dz-col-6'
			};
		}

		if (this.shouldOverridePadding) {
			this.contentClass = {
				appName: this.contentClass.appName + ' col-padding-override dz-col-padding-override',
				actionButtons: this.contentClass.actionButtons + ' col-padding-override dz-col-padding-override'
			};
		}
	}

}
